import React from 'react';

const routes = [
	{
		path: '/',
		exact: true,
		name: 'root',
		component: React.lazy(() => import('../pages/Featured')),
	},
	{
		path: '/league-pass',
		exact: true,
		name: 'leaguepass',
		component: React.lazy(() => import('../pages/Videos')),
	},
	{
		path: '/packages',
		name: 'packages',
		externalPage: true,
		component: React.lazy(() => import('../pages/Packages')),
	},
	{
		path: '/streaming-subscriptions',
		name: 'packages',
		externalPage: true,
		component: React.lazy(() => import('../pages/Packages')),
	},
	{
		path: '/video/:seoName',
		name: 'video',
		noScroll: true,
		component: React.lazy(() => import('../pages/Video')),
	},
	{
		path: '/embed2',
		name: 'embed',
		externalPage: true,
		component: React.lazy(() => import('../pages/Embed')),
	},
	{
		/*
		@deprecated
		 */
		path: '/category/:seoName',
		name: 'category',
		component: React.lazy(() => import('../pages/Category')),
	},
	{
		path: '/list/feed/:slug',
		exact: true,
		name: 'videolist',
		component: React.lazy(() => import('../pages/ESVideoList')),
	},
	{
		path: '/list/:curation/:slug',
		exact: true,
		name: 'videolist',
		component: React.lazy(() => import('../pages/NBAVideoList')),
	},
	{
		path: '/nba-tv',
		exact: true,
		name: 'nbatv',
		component: React.lazy(() => import('../pages/NBATv')),
	},
	{
		path: '/nba-tv/schedule',
		exact: true,
		name: 'tvguide',
		component: React.lazy(() => import('../pages/Schedule')),
	},
	{
		path: '/channel/:seoName',
		name: 'channel',
		noScroll: true,
		component: React.lazy(() => import('../pages/Channel')),
	},
	{
		path: '/featured',
		name: 'featured',
		component: React.lazy(() => import('../pages/Featured')),
	},
	{
		path: '/nba-tv/series',
		name: 'shows',
		component: React.lazy(() => import('../pages/Shows')),
	},
	{
		path: '/nba-tv/classic-games',
		name: 'classicgames',
		component: React.lazy(() => import('../pages/ClassicGames')),
	},
	{
		path: '/page/search',
		name: 'search',
		component: React.lazy(() => import('../pages/Search')),
	},
	{
		path: '/event/:seoName',
		name: 'event',
		noScroll: true,
		component: React.lazy(() => import('../pages/Event')),
	},
	{
		path: '/secure/subscription',
		name: 'subscription',
		component: React.lazy(() => import('../pages/Subscription')),
		externalPage: true,
	},
	{
		path: '/account/:pageName',
		name: 'account',
		component: React.lazy(() => import('../pages/Account')),
		externalPage: true,
	},
	{
		path: '/page/business',
		name: 'business',
		externalPage: true,
		component: React.lazy(() => import('../pages/Static')),
	},
	{
		path: '/page/music',
		name: 'music',
		externalPage: true,
		component: React.lazy(() => import('../pages/Static')),
	},
	{
		path: '/gridtest',
		name: 'gridtest',
		component: React.lazy(() => import('../pages/GridTest')),
	},
	{
		path: '/itemtest',
		name: 'itemtest',
		component: React.lazy(() => import('../pages/ItemTest')),
	},
	{
		path: '/player-test',
		name: 'playertest',
		component: React.lazy(() => import('../pages/PlayerTest')),
	},
	{
		path: '/player-test-no-epg',
		name: 'playertestnoepg',
		component: React.lazy(() => import('../pages/PlayerTestNoEpg')),
	},
	{
		path: '/skeleton-test',
		name: 'skeleton-test',
		component: React.lazy(() => import('../pages/SkeletonTest')),
	},
	{
		path: '*',
		name: 'notfound',
		component: React.lazy(() => import('../pages/NotFound')),
	},
];

export default routes;
